export function getTenant() {
 
/*
 export function getTenant() {
  // Example: /tenant1/dashboard → ["", "tenant1", "dashboard"]
  const segments = window.location.pathname.split("/").filter(Boolean);

  // If the URL has no segments, treat as default tenant
  if (segments.length === 0) return "default";

  const tenant = segments[0].toLowerCase(); // first part of path

  return tenant || "default";
}
  
  */
  return "centrosacre";
}